export const FIELD_META: Record<
  string,
  { labelKey: string; tabKey: string }
> = {
  brand: { labelKey: 'general.brand_name', tabKey: 'base_information' },
  short_description: {
    labelKey: 'general.short_company_description',
    tabKey: 'base_information',
  },
  description: {
    labelKey: 'general.company_description',
    tabKey: 'base_information',
  },
  contact_phone: { labelKey: 'general.phone', tabKey: 'base_information' },
  contact_email: { labelKey: 'general.email', tabKey: 'base_information' },
};

export type ValidationError = {
  errorFields?: { name: (string | number)[]; errors: string[] }[];
};

export type ValidationReport = {
  lines: string[];
  counts: Record<string, number>;
};

export const mergeReports = (
  ...reports: ValidationReport[]
): ValidationReport => {
  const lines: string[] = [];
  const counts: Record<string, number> = {};
  reports.forEach((r) => {
    lines.push(...r.lines);
    Object.entries(r.counts).forEach(([k, v]) => {
      counts[k] = (counts[k] || 0) + v;
    });
  });
  return { lines, counts };
};
